import { Link } from "react-router-dom";

const stats = [
  { value: "6+", label: "剧情章节解析" },
  { value: "6", label: "核心角色档案" },
  { value: "6+", label: "最新剧集资讯" },
];

export default function IntroBand() {
  return (
    <section className="w-full px-4 md:px-8 pb-16 md:pb-24">
      <div className="max-w-[1200px] mx-auto bg-background-100 border border-background-200 rounded-lg overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10 lg:p-12">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700 uppercase tracking-wider mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              About the series
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              关于《年轻的母亲3》
            </h2>
            <p className="mt-4 text-sm md:text-[15px] text-foreground-600 leading-relaxed">
              《年轻的母亲3》延续系列一贯细腻温暖的家庭叙事，讲述林静书带着女儿回到故乡，
              在重逢与往事之间重新理解“母亲”这一身份的故事。本站围绕该剧建立完整的资料体系，
              涵盖全集剧情介绍、角色深度分析与最新资讯，致力于成为该剧爱好者最系统的内容入口。
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解网站与联系
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
              <Link
                to="/search"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-search-line"></i></span>
                全站搜索
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-3 bg-background-50 border-t lg:border-t-0 lg:border-l border-background-200">
            {stats.map((s, idx) => (
              <div
                key={s.label}
                className={`flex flex-col items-center justify-center text-center px-3 py-8 md:py-10 ${
                  idx > 0 ? "border-l border-background-200" : ""
                }`}
              >
                <span className="font-heading font-bold text-3xl md:text-4xl text-primary-600">{s.value}</span>
                <span className="mt-2 text-xs md:text-sm text-foreground-600 leading-snug">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}